import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";
import { Home } from "@App/Pages/Partner/MobileGarantie/Home";
import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";
import { MobileGarantieLayout } from "@App/Pages/Partner/MobileGarantie/Layout";

export function MobileGarantie() {
  const { config } = useOrganizationConfig();

  return (
    <DefaultRoutes
      layout={
        <MobileGarantieLayout
          logos={config.navbar.logos}
          backToPartnerButton={config.navbar.backToPartnerButton}
        />
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
